module.exports = __webpack_public_path__ + "static/img/公司3.5525aa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/公司3.jpg
// module id = 2lfs
// module chunks = 1